export enum SolutionsEnum {
	MONITOR = 'monitor',
	DETECTION = 'detection',
	VERIFICATION = 'verification',
	ALERTS = 'alerts'
}

export enum SlidesTypeEnum {
	TEAM = 'team',
	ADVISORS = 'advisors'
}
export type SlideTeamType = TeamType | AdvisorType;

export interface TeamType {
	image: string;
	name: string;
	summary: string;
	id: string;
	position: string;
	linkedin?: string;
	mail?: string;
	fake: string[];
}

export interface AdvisorType {
	image: string;
	name: string;
	summary: string;
	id: string;
	position: string;
}

export interface Job {
	id: string;
	title: string;
	location: string;
	mission: string;
	requirements: string[];
	benefits: string[];
	hiringProcess: string[];
	postedDate: Date | string;
	contractType: string;
}

export type FormStatus = 'idle' | 'loading' | 'success' | 'error';

export enum IndustryTags {
	Banking = 'banking',
	Telecom = 'telecom',
	Health = 'health',
	Food = 'food',
	Fashion = 'fashion',
	Tourism = 'tourism',
	Energy = 'energy',
	Other = 'other'
}

export interface ContactFormData {
	name: string;
	lastname: string;
	email: string;
	phone: string;
	company: string;
	sector: IndustryTags;
	message: string;
	subject: string;
}

export interface JobFormData {
	name: string;
	lastname: string;
	email: string;
	linkedin: string;
	message: string;
	resume: {
		name: string;
		type: string;
		size: number;
		data: string; // Base64
	} | null;
	subject: string;
}
